import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { Grid, Input, Button } from 'semantic-ui-react';
import DeleteIcon from '@material-ui/icons/Delete';
import Server from '../../../functions/server';
import $ from "jquery";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

class Othercharge extends React.Component {

  state = {
    otherCharge: false,
    otherChargeArray: [], expenseMaster: []
  }

  componentDidMount() {
    this.getExpense();
  }

  getExpense() {
    let context = this;
    context.setState({ load: true })
    $.ajax({
      type: 'POST',
      url: Server() + 'WebMaster/ExpenseMaster/getplaceorderexpense.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.addExpenseFromQuotation(data);
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  addExpenseFromQuotation(expenseMaster) {
    let items = this.props.items;
    let otherChargeAva = 0;
    let otherChargeArray = this.state.otherChargeArray;
    let length = 0;
    items.map((c) => {
      expenseMaster.map((v) => {
        if (c.sparename == v.name) {
          otherChargeAva = 1;
          v.tax = c.tax;
          v.amount = c.uprice;
          v.orderdetailsId = c.orderdetailsId;
          otherChargeArray.push({ id: length, orderdetailsId: c.orderdetailsId, oldquantity: 1, tax: c.tax, amount: c.uprice, dropdownValue: v.name+'->'+length,  name: v.name })
          length++;
        }
      })
    })
    if (otherChargeAva == 1) {
      this.setState({ expenseMaster, otherChargeArray, load: false, otherCharge: true })
    }
    else {
      this.setState({ expenseMaster, otherChargeArray, load: false })
    }
    this.submit(expenseMaster);
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  onSubmit() {
    let otherChargeArray = this.state.otherChargeArray;
    this.submit(otherChargeArray);
  }

  submit(expenseMaster) {
    let item = this.props.items;
    let newItem = [];
    item.map((c) => {
      if (c.partno != '0' || c.partname == 'TCS') {
        newItem.push(c);
      }
    })
    let id = 0;
    
    expenseMaster.map((c) => {
      if (c.amount) {
        id = id + 1;
        let amount = Number(c.amount);
        let tax = Number(c.tax);
        let info = c.name;
        let expenseId = c.id;
        let taxablePrice = amount + ((amount * tax)/100);
        newItem.push({ ava_stocks: '',  branch: '', brand: '', brand_name: '', discountper: 0,  discountrs: 0,
                  id: id, orderdetailsId: c.orderdetailsId, part_id: '', partcode: '0', partname: info, partno: '0',
                  point: 0, quantity: 1, rackno: expenseId, status: "Othercharge", tax: tax, totals: amount,
                  totprice: taxablePrice, totprices: amount,
                  uprice: amount, weight: '', oldquantity: '', expense: 1 });
      }
    })
    this.props.otherChangesUpdate(newItem);
    this.props.updateDynamicState('items', newItem);
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked })
  };

  addOtherChargeArray() {
    let otherChargeArray = this.state.otherChargeArray;
    let length = otherChargeArray.length;
    length = length + 1;
    otherChargeArray.push({ id: length, orderdetailsId: 0 })
    this.setState({ otherChargeArray })
  }

  deleteOtherChargeArray(id, obj) {
    let otherChargeArrayOriginal = this.state.otherChargeArray;
    let item = this.props.items;
    let removedItems = this.props.removedItems;
    let expenseMaster = this.state.expenseMaster;
    let otherChargeArray = [];
    let newItem = [];
    let expanceName = '';
    otherChargeArrayOriginal.map((c) => {
      if (c.id != id) {
        otherChargeArray.push(c);
      }
      newItem = [];
      item.map((cc) => {
        if (cc.orderdetailsId == obj.orderdetailsId) {
          removedItems.push(cc)
        }
        else {
          newItem.push(cc);
        }
      })
    })
    let i = 1;
    otherChargeArray.map((c) => { c.id = i++; })
    this.setState({ otherChargeArray })
    this.props.updateDynamicState('items', newItem);
    this.props.updateDynamicState('removedItems', removedItems);
  }

  onChangeOtherCharge = event => {
    let value = event.target.value;
    let info = value.split('->')[0];
    let id = value.split('->')[1];
    let tax = value.split('->')[2];
    let hsncode = value.split('->')[3];
    let otherChargeArray = this.state.otherChargeArray;
    otherChargeArray.map((c) => {
      if (c.id == id) {
        c.name = info;
        c.dropdownValue = value;
        c.tax = tax;
      }
    })
    this.setState({ otherChargeArray })
  }

  otherChargeTextBox = (type, id) => (f, { value }) => {
    let otherChargeArray = this.state.otherChargeArray;
    otherChargeArray.map((c) => {
      if (c.id == id) {
        if (type == 'amount') {
          c.amount = value;
        }
        if (type == 'tax') {
          c.tax = value;
        }
      }
    })
    this.setState({ otherChargeArray })
  }

  render() {
    let sino = 1;
    let si_no = 1;
    return (
      <div>
        <div style={{display: 'flex'}}>
          <Checkbox checked={this.state.otherCharge} onChange={this.handleChange('otherCharge')}
            value="otherCharge" />
          <div style={{paddingTop: '2.5%'}}>Other Charges</div>
        </div>
        { this.state.otherCharge ?
          (
            <div>
              <table id="table" width="100%">
                <tr>
                  <th id='tableheader' style={{width: '4%'}}><center>#</center></th>
                  <th id='tableheader' style={{width: '25%'}}><center>Info</center></th>
                  <th id='tableheader' style={{width: '15%'}}><center>Tax</center></th>
                  <th id='tableheader'><center>Amount</center></th>
                  <th id='tableheader'><center>Total</center></th>
                  <th id='tableheader' style={{width: '10%'}}><center>Remove</center></th>
                </tr>
                {
                  this.state.otherChargeArray.map((d) => {
                    let amount = this.convertToNumber(d.amount);
                    let tax = this.convertToNumber(d.tax);
                    return (
                      <tr>
                        <td>{si_no++}</td>
                        <td>
                          <FormControl style={{width: '100%'}}>
                            <Select labelId="demo-simple-select-label"
                            onChange={this.onChangeOtherCharge}
                              id="demo-simple-select" value={d.dropdownValue}>
                                {
                                  this.state.expenseMaster.map((c) => {
                                    return (
                                      <MenuItem value={c.name+'->'+d.id+'->'+c.tax+'->'+c.hsncode}>{c.name}</MenuItem>
                                    )
                                  })
                                }
                            </Select>
                          </FormControl>
                        </td>
                        <td><Input fluid type='number' disabled value={d.tax} placeholder='Tax' onChange={this.otherChargeTextBox('tax', d.id)} /></td>
                        <td><Input fluid type='number' value={d.amount} placeholder='Amount' onChange={this.otherChargeTextBox('amount', d.id)} /></td>
                        <td>{((amount + (amount * tax)/100))}</td>
                        <td onClick={this.deleteOtherChargeArray.bind(this, d.id, d)}><center><DeleteIcon /></center></td>
                      </tr>
                    )
                  })
                }
              </table>
              <center style={{marginTop: 10}}>
                <Button onClick={this.addOtherChargeArray.bind(this)}>Add</Button>
                <Button onClick={this.onSubmit.bind(this)}>Submit</Button>
              </center>
            </div>
          ) : (<div></div>)
        }
      </div>
    );
  }
}

export default Othercharge;
